import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import StoryCard from '../components/StoryCard';
import LoadingSpinner from '../components/LoadingSpinner';
import ErrorMessage from '../components/ErrorMessage';
import { getUserStories, deleteStory } from '../services/firebase-stories';
import './LibraryPage.css';

const LibraryPage = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch user's stories on component mount
  useEffect(() => {
    fetchStories();
  }, []);

  // Fetch stories from Firebase
  const fetchStories = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const userStories = await getUserStories();
      setStories(userStories);
      
      console.log('Fetched stories:', userStories);
    } catch (err) {
      console.error('Error fetching stories:', err);
      setError({
        message: 'Could not load your stories',
        details: err.message
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle story deletion
  const handleDeleteStory = async (storyId) => {
    try {
      setLoading(true);
      await deleteStory(storyId);
      
      // Update local state by removing deleted story
      setStories(prev => prev.filter(story => story.id !== storyId));
      
      console.log('Story deleted successfully:', storyId);
    } catch (err) {
      console.error('Error deleting story:', err);
      setError({
        message: 'Could not delete story',
        details: err.message
      });
    } finally {
      setLoading(false);
    }
  };

  // Render loading state
  if (loading && stories.length === 0) {
    return (
      <div className="library-page">
        <h1 className="page-title">Your <em>Story</em> Library</h1>
        <LoadingSpinner message="Loading your magical tales..." />
      </div>
    );
  }

  return (
    <div className="library-page">
      <h1 className="page-title">Your <em>Story</em> Library</h1>
      
      {/* Show error if exists */}
      {error && (
        <ErrorMessage 
          message={error.message} 
          details={error.details}
          onDismiss={() => setError(null)}
        />
      )}
      
      {/* Show stories or empty state */}
      <div className="library-content">
        {stories.length === 0 ? (
          <div className="empty-library">
            <div className="empty-library-icon">📚</div>
            <h2>Your library is empty</h2>
            <p>Create your first magical tale to see it here!</p>
            <Link to="/create" className="pill-button primary">
              ✨ Create New Story
            </Link>
          </div>
        ) : (
          <div className="story-grid">
            {stories.map(story => (
              <StoryCard 
                key={story.id} 
                story={story} 
                onDelete={handleDeleteStory} 
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LibraryPage;
